// extracted by mini-css-extract-plugin
module.exports = {"card":"CheckQueue-module__card___2hCNi","header":"CheckQueue-module__header___3-sx4","table":"CheckQueue-module__table___26fyz"};